function buildNOXFromLiveStats(dataArr) {
  let result = []
  let previousValidValues = {
    noxIndex: null
  }

  if (!dataArr || !dataArr.length) {
    return []
  }
  
  for (let i = 0; i < dataArr.length; i++) {
    let relevantDataArr = []
    relevantDataArr.push(dataArr[i].datetime) // Index 0 will hold datetime

    // NOX Index from sen5x
    let noxIndex = parseFloat(dataArr[i].tstat_read_data.sen5x?.nox_index || 0)
    if (noxIndex === 0 && previousValidValues.noxIndex !== null) {
      noxIndex = previousValidValues.noxIndex
    }
    if (noxIndex !== 0) {
      previousValidValues.noxIndex = noxIndex
    }
    relevantDataArr.push(noxIndex)

    result.push(relevantDataArr)
  }

  return result
}

function formatNOXData(dataArr) {
  const chartData = dataArr.map((dataItem) => {
    return [
      new Date(dataItem[0]),           // Datetime
      dataItem[1]           // NOX Index
    ]
  })

  return chartData
}

export {
  buildNOXFromLiveStats,
  formatNOXData
}